/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Menu } from 'antd';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import isBoolean from 'lodash/isBoolean';

import useMediaQuery from '@src/hooks/useMediaQuery';

import useTranslation from '@src/hooks/useTranslation';
import { HRHomeIcon } from '@src/components/common/icons/HRHomeIcon';
import { SlidePersonalAreaTimeIcon } from '@src/components/common/icons/SlidePersonalAreaTimeIcon';
import { SlideFilePlusIcon } from '@src/components/common/icons/SlideFilePlusIcon';
import { SlideInboxIcon } from '@src/components/common/icons/SlideInboxIcon';
import { SlideApprovalIcon } from '@src/components/common/icons/SlideApprovalIcon';
import { SideMenuRightArrowIcon } from '@src/components/common/icons/SideMenuRightArrowIcon';
import { SwitchHRLogoIconWhite } from '@src/components/common/icons/SwitchHRLogoIconWhite';
import { SwitchCourseLogoIconGreen } from '@src/components/common/icons/SwitchCourseLogoIconGreen';
import { ScheduleManagementIcon } from '@src/components/common/icons/ScheduleManagementIcon';
import { PersonalAreaIcon } from '@src/components/common/icons/PersonalAreaIcon';
import { ReportIssueIcon } from '@src/components/common/icons/ReportIssueIcon';
import { OutingPunchRecordIcon } from '@src/components/common/icons/OutingPunchRecordIcon';
import { PersonalPayrollMenuIcon } from '@src/components/common/icons/PersonalPayrollMenuIcon';
import { getApprovalCenterCall } from '@src/store/actions/hrCenter';

import { RowWrapper } from '../hr/punchIn/styles';
import RecordIssueModal from './recordIssueModal';

const AreaContent = styled.div`
	font-size: 14px;
	color: #676767;
	display: flex;
	flex-direction: row;
	align-items: center;
	white-space: nowrap;
	padding: 9px 0px 4px 16px;
	background: #FFF;
	font-weight: 400;
	height: 36px;
`;

const Divider = styled.div.attrs({ className: 'divider' })`
	width: calc(100% - 32px);
	height: 1px;
	background: #E9E9E9;
	margin: 0 16px;
`;

const StyledMenu = styled(Menu)`
	margin: 0px !important;
	width: calc(100% - 8px) !important;
	border-radius: 8px !important;
	&.ant-menu {
		height: unset !important;
	}
	.ant-menu-item-selected {
		color: #3091fd !important;
		&:hover {
			background: #D1E7F0 !important;
			color: #3091fd !important;
		}
		.fill-hover {
			path {
				fill:#3091FD;
			}
		}
		.stroke-hover {
			path {
				stroke:#3091FD;
			}
		}
	}
`;

const StyledMenuItem = styled(Menu.Item)`
	padding-left: 15px !important;
	margin-top: unset !important;
	margin-bottom: 4px !important;
	height: 40px !important;
	color: #333;
	font-size: 14px !important;
	font-weight: 400 !important;
	border-radius: 8px !important;
	:hover {
		background: #F5F5F7 !important;
		color: #333 !important;
	}

	::after{
		border-right: unset !important;
	}
	
	.ant-menu-title-content {
		display: flex;
		align-items: center;
	}
	svg {
		flex-shrink: 0;
		overflow: unset !important;
	}
	@media ${props => props.theme.device.mobile} {
		font-size: 16px !important;
	}
`;

const StyledMenuSubMenu = styled(Menu.SubMenu)`
	position: relative;
	margin-bottom: 4px !important;
	.arrow-icon {
		transform: rotate(0deg);
	}
	.ant-menu {
		background-color: #FFF !important;
	}
	.ant-menu-submenu-title {
		border-radius: 8px !important;
		padding-left: 15px !important;
		margin-top: unset !important;
		margin-bottom: unset !important;
		height: 40px !important;
		padding-right: 8px !important;
		:hover {
			background: #F5F5F7 !important;
			color: #333 !important;
		}
	}
	&.ant-menu-submenu-open {
		.arrow-icon {
			transform: rotate(90deg);
		}
	}
	&.ant-menu-submenu-selected {
		& .ant-menu-submenu-title {
			color: #333 !important;
		}
	}
	/* 特定解析度/縮放比例下 icon 會被 flex 壓縮或被 svg 預設 overflow: hidden 裁邊，不能只限 smTablet/collapsed */
	svg {
		flex-shrink: 0;
		overflow: unset !important;
	}
	@media ${props => props.theme.device.mobile} {
		font-size: 16px !important;
	}
`;

const SubMenuContent = styled.div`
	display: flex;
	align-items: center;
`;

const SubMenuItem = styled(Menu.Item)`
	padding-left: 42px !important;
	background-color: #FFF !important;
	margin-top: unset !important;
	margin-bottom: 4px !important;
	height: 40px !important;
	border-radius: 8px !important;
	:hover {
		background: #F5F5F7 !important;
		color: #333 !important;
	}
	::after{
		border-right: unset !important;
	}
	&.ant-menu-item-selected {
		background: #E7F4F9 !important;
		color: #3091FD !important;
	}
	@media ${props => props.theme.device.mobile} {
		font-size: 16px !important;
	}
`;

const StyledPersonalAreaTimeIcon = styled(SlidePersonalAreaTimeIcon)`
	margin-right: 8px;
`;

const StyledPersonalAreaIcon = styled(PersonalAreaIcon)`
	margin-right: 8px;
`;

const StyledFilePlusIcon = styled(SlideFilePlusIcon)`
	margin-right: 8px;
	path {
		fill:#222;
	}
`;

const StyledInboxIcon = styled(SlideInboxIcon)`
	margin-right: 8px;
	path {
		stroke:#222;
	}
`;

const StyledApprovalIcon = styled(SlideApprovalIcon)`
	margin-right: 8px;
	path {
		stroke:#222;
	}
`;

const SystemOptionWrapper = styled(RowWrapper)`
	padding: 8px 16px;
	margin-bottom: 4px;
	gap: 8px;
	justify-content: flex-start;
	cursor: pointer;
	:hover {
		border-radius: 8px;
		background: #F5F5F7;
	}
`;

const SystemText = styled.div`
	cursor: pointer;
`;

const SwitchWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const StyledHrHomeIcon = styled(HRHomeIcon)`
	margin-right: 8px;
`;

const StyledScheduleManagementIcon = styled(ScheduleManagementIcon)`
	margin-right: 8px;
`;

const ReportWrapper = styled.div`
	padding: 36px 0px 12px 16px;
	margin-bottom: 0;
`;

const ReportButton = styled.div`
	border-radius: 4px;
	border: 1px solid var(--Line, #E9E9E9);
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 4px 12px;
	background: #FFF;
	width: fit-content;
	cursor: pointer;
	svg {
		margin-right: 8px;
		margin-bottom: 2px;
	}
	:hover {
		background: #F5F5F7;
	}
`;

const ReportText = styled.div`
	color: #676767;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	@media ${props => props.theme.device.mobile} {
		font-size: 16px;
	}
`;

const MenuWrapper = styled.div`
	height: 100%;
	background: #FFF;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	overflow-y: auto;
	touch-action: pan-y;
	-webkit-overflow-scrolling: touch;
`;

const StyledOutingPunchRecordIcon = styled(OutingPunchRecordIcon)`
	margin-right: 8px;
`;

const StyledPersonalPayrollMenuIcon = styled(PersonalPayrollMenuIcon)`
	margin-right: 8px;
`;

const HrMenu = ({
	className,
	collapsed,
	isPWA,
	defaultActive,
	showOutingPunch,
	onClick,
}: {
	className?: string;
	collapsed: boolean;
	isPWA?: boolean;
	defaultActive?: string;
	showOutingPunch: boolean;
	onClick: (path: string) => void;
}): JSX.Element => {
	const { t } = useTranslation();
	const router = useRouter();
	const dispatch = useDispatch();
	const detail = useSelector((state: RootStateOrAny) => state.hrCenter.approvalCenter);
	const { themes } = useSelector((state: RootStateOrAny) => state.themeClient) as any;
	const showScheduleManagement = themes?.shift_scheduler;
	const showPersonalShift = !isBoolean(themes?.hr_personal_shift_enabled) || themes?.hr_personal_shift_enabled;
	const { pathname, query } = router;
	useEffect(() => {
		dispatch(getApprovalCenterCall());
	}, []);
	const { mediaMatch: { isMobile, isSmTablet } } = useMediaQuery();
	const [isRecordIssueModalActive, setIsRecordIssueModalActive] = useState(false);
	const openKeys = defaultActive ? [defaultActive] : [];
	const applicationPaths = ['/hr/application', '/hr/leave', '/hr/overtime', '/hr/make-up-punch'];
	if (applicationPaths.includes(pathname)) {
		openKeys.push('application');
	}

	let selectKey = '';

	if (['/hr/overtime-form'].includes(pathname)) {
		selectKey = '/hr/overtime';
	}
	if (['/hr/leave-form'].includes(pathname)) {
		selectKey = '/hr/leave';
	}
	if (['/hr/make-up-punch-form'].includes(pathname)) {
		selectKey = '/hr/make-up-punch';
	}
	if ([
		'/hr/overtime-form',
		'/hr/leave-form',
		'/hr/make-up-punch-form',
	].includes(pathname) && query.type === 'approver') {
		selectKey = '/hr/admin-center';
	}

	if (query.isApprover === 'true') {
		selectKey = '/hr/admin-center';
	}

	if ([
		'/hr/overtime/approver',
		'/hr/leave/approver',
		'/hr/make-up-punch/approver',
	].includes(pathname)) {
		selectKey = '/hr/admin-center';
	}

	if (pathname.startsWith('/hr/shift-settings')) {
		selectKey = '/hr/shift-settings';
	}

	return (
		<>
			<RecordIssueModal
				isActive={isRecordIssueModalActive}
				handleClose={() => setIsRecordIssueModalActive(false)}
			/>
			<MenuWrapper className={className}>
				<div>
					{
						isPWA && (themes?.can_switch_course_system || themes?.can_switch_hr_system) ? (
							<>
								<AreaContent>
									{t('hr:common:action:switch_system')}
								</AreaContent>
								<SwitchWrapper>
									{
										themes?.can_switch_hr_system && (
											<SystemOptionWrapper onClick={() => onClick('/hr')}>
												<SwitchHRLogoIconWhite />
												<SystemText>
													{t('common:brand:hr_system_name')}
												</SystemText>
											</SystemOptionWrapper>
										)
									}
									{
										themes?.can_switch_course_system && (
											<SystemOptionWrapper onClick={() => onClick('/training')}>
												<SwitchCourseLogoIconGreen />
												<SystemText>
													{t('common:brand:training_system_name')}
												</SystemText>
											</SystemOptionWrapper>
										)
									}
								</SwitchWrapper>
								<Divider />
							</>
						) : null
					}
					<StyledMenu
						mode="inline"
						selectedKeys={[pathname, selectKey]}
						defaultOpenKeys={openKeys}
						style={{ height: '100%', borderRight: 0 }}
						inlineCollapsed={false}
						inlineIndent={54}
					>
						<StyledMenuItem onClick={() => onClick('/hr')}>
							<StyledHrHomeIcon />
							{t('hr:menu:home')}
						</StyledMenuItem>
					</StyledMenu>
					<Divider />
					<AreaContent>
						{t('hr:menu:personal_area:title')}
					</AreaContent>
					<StyledMenu
						mode="inline"
						selectedKeys={[pathname, selectKey]}
						defaultOpenKeys={openKeys}
						style={{ height: '100%', borderRight: 0 }}
						inlineCollapsed={false}
						inlineIndent={54}
					>
						<StyledMenuItem key="/hr/attendance-history" onClick={() => onClick('/hr/attendance-history')}>
							<StyledPersonalAreaTimeIcon className="stroke-hover" />
							{t('hr:menu:personal_area:attendance_record')}
						</StyledMenuItem>
						{showOutingPunch && (
							<StyledMenuItem key="/hr/outing-punch-record" onClick={() => onClick('/hr/outing-punch-record')}>
								<StyledOutingPunchRecordIcon className="stroke-hover" />
								{t('hr:menu:personal_area:outing_punch_record')}
							</StyledMenuItem>
						)}
						{
							showPersonalShift && (
								<StyledMenuItem
									key="/hr/personal-shiftschedule"
									onClick={() => onClick('/hr/personal-shiftschedule')}
								>
									<StyledPersonalAreaIcon className="stroke-hover" />
									{t('hr:menu:personal_area:personal_shift')}
								</StyledMenuItem>
							)
						}
						<StyledMenuItem key="/hr/leave/type" onClick={() => onClick('/hr/leave/type')}>
							<StyledFilePlusIcon className="fill-hover" />
							{t('hr:menu:personal_area:leave')}
						</StyledMenuItem>
						<StyledMenuSubMenu
							key="application"
							title={(
								<SubMenuContent>
									<StyledInboxIcon className="stroke-hover" />
									<span>{t('hr:menu:personal_area:form_application:title')}</span>
								</SubMenuContent>
							)}
							expandIcon={<SideMenuRightArrowIcon className="arrow-icon" />}
						>
							<SubMenuItem key="/hr/overtime" onClick={() => onClick('/hr/overtime')}>
								{t('hr:menu:personal_area:form_application:overtime_form')}
							</SubMenuItem>
							<SubMenuItem key="/hr/make-up-punch" onClick={() => onClick('/hr/make-up-punch')}>
								{t('hr:menu:personal_area:form_application:make_up_punch_form')}
							</SubMenuItem>
							<SubMenuItem key="/hr/leave" onClick={() => onClick('/hr/leave')}>
								{t('hr:menu:personal_area:form_application:leave_form')}
							</SubMenuItem>
							<SubMenuItem key="/hr/application" onClick={() => onClick('/hr/application')}>
								<div>{t('hr:menu:personal_area:form_application:application_record')}</div>
							</SubMenuItem>
						</StyledMenuSubMenu>
						<StyledMenuItem key="/hr/personal-payroll" onClick={() => onClick('/hr/personal-payroll')}>
							<StyledPersonalPayrollMenuIcon className="stroke-hover" />
							{t('hr:menu:personal_area:payroll')}
						</StyledMenuItem>
					</StyledMenu>
					{
						detail?.show_approval_center && (
							<>
								<Divider />
								<AreaContent>
									{(isMobile || isSmTablet) && !isPWA ? (
										t('hr:menu:admin_area:short')
									) : (
										t('hr:menu:admin_area:title')
									)}
								</AreaContent>
								<StyledMenu
									mode="inline"
									selectedKeys={[pathname, selectKey]}
									style={{ height: '100%', borderRight: 0 }}
									inlineCollapsed={collapsed}
									inlineIndent={54}
								>
									<StyledMenuItem key="/hr/admin-center" onClick={() => onClick('/hr/admin-center')}>
										<StyledApprovalIcon className="stroke-hover" />
										{t('hr:menu:admin_area:approval_center')}
									</StyledMenuItem>
								</StyledMenu>
							</>
						)
					}
					{
						showScheduleManagement && (
							<>
								<Divider />
								<AreaContent>
									{t('hr:menu:schedule_management:title')}
								</AreaContent>
								<StyledMenu
									mode="inline"
									selectedKeys={[pathname, selectKey]}
									style={{ height: '100%', borderRight: 0 }}
									inlineCollapsed={collapsed}
									inlineIndent={54}
								>
									<StyledMenuItem key="/hr/shift-settings" onClick={() => onClick('/hr/shift-settings')}>
										<StyledScheduleManagementIcon className="stroke-hover" />
										{t('hr:menu:schedule_management:schedule_operations')}
									</StyledMenuItem>
								</StyledMenu>
							</>
						)
					}
				</div>
				<ReportWrapper>
					<ReportButton onClick={() => setIsRecordIssueModalActive(true)}>
						<ReportIssueIcon />
						<ReportText>{t('hr:general:report_issue:title')}</ReportText>
					</ReportButton>
				</ReportWrapper>
			</MenuWrapper>
		</>
	);
};

export default HrMenu;
